import { useTranslation } from 'react-i18next';

import { UnifiedSendEmailRequest } from '@this+that/models';
import log from 'loglevel';

import { sendEmails } from '../../../services/unifiedEmailAction.service';
import { useCustomToast } from '../../useCustomToast';

interface EmailActionConfig {
  setLoading: (value: boolean) => void;
  successKey: string;
  errorKey: string;
}

export const useEmailAction = (getConfig: () => EmailActionConfig) => {
  const { t } = useTranslation();
  const { successMessage, errorMessage } = useCustomToast();

  const handleEmailAction = async (payload: UnifiedSendEmailRequest) => {
    const { setLoading, successKey, errorKey } = getConfig();
    try {
      setLoading(true);
      const data = await sendEmails(payload);
      successMessage(t(successKey));
      return data;
    } catch (error) {
      log.error(error);
      errorMessage(t(errorKey));
    } finally {
      setLoading(false);
    }
  };

  return { handleEmailAction };
};
